(() => {
    const cookieNotice = document.querySelector('[data-cookie-notice]');
    const cookieNoticeButton = document.querySelector('[data-cookie-notice-button]');
    const expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() + 1);

    if (!cookieNotice) {
        return;
    }

    try {
        if (document.cookie.indexOf('productwebsiteCookieNotice') === -1) {
            cookieNotice.removeAttribute('hidden');
        }
    } catch (error) {
        // nothing
    }

    cookieNoticeButton.addEventListener('click', (event) => {
        event.preventDefault();

        cookieNotice.setAttribute('hidden', '');

        try {
            document.cookie = "productwebsiteCookieNotice=1;expires=" + expiryDate.toUTCString();
        } catch (error) {
            // nothing
        }
    });
})();
